export const environment = {
  production: false,
  apiBaseUrl: 'https://localhost:55203',
};
